export const DashboardWidget = {
  PipelineStatistics: "pipelineStatistics",
  HeightProfileChart: "heightProfileChart",
  WMSWidget: "wmsWidget",
  WMSLegend: "wmsLegend",
  SelectClickedPipeline: "SelectClickedPipeline",
} as const;
